import axios from 'axios';
import { ITaskChangePayload, ITaskChangeResponse } from 'entities/Tasks/Tasks.models';

const basePath = 'task/status';

export const tasksTransport = {
  changeEventTaskStatus: (payload: ITaskChangePayload): Promise<ITaskChangeResponse> => axios.patch(`${basePath}`, payload),
};
